export default "__VITE_ASSET__DIiFo0oi__"